import { TabControl } from "@components/ui/TabControl"
import { ResultBrowser } from "@components/util/ResultBrowser"
import { VenueTile } from "@components/venues/VenueTile"
import { defineBlock } from "eddev/blocks"
import { useSearchParams } from "eddev/routing"
import { AnimatePresence, motion } from "motion/react"
import { useMemo } from "react"

export const meta: BlockMeta = {
  title: "Venue Grid",
  description: "A listing of venues",
  icon: "building",
  tags: ["#subpage-layout"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

export default defineBlock("venue/venue-listing", (props) => {
  const venues = props.venues

  // Query parameters
  const [_, filters] = useSearchParams({
    district: "all",
  })

  // // Build a list of all the cards, so they don't have to be re-rendered on each scroll event
  const cards = useMemo(() => {
    let results = venues ?? []

    if (filters.get("district") !== "all") {
      results = results.filter((strand) => strand?.district?.slug === filters.get("district"))
    }

    return results.map((post, i) => (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.4 } }}
        transition={{
          when: "beforeChildren",
          duration: 0.3,
        }}
        key={post?.uri!}
        layoutId={post?.uri!}
        layout="position"
        className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3"
      >
        <VenueTile venue={post!} />
        <div className="h-5" />
      </motion.div>
    ))
  }, [venues, filters.get("district")])

  const districts = useMemo(() => {
    return (
      props.districts?.nodes
        ?.filter((district) => venues?.some((v) => v?.district?.slug === district.slug))
        .map((district) => ({
          label: district.name!,
          value: district.slug!,
        })) ?? []
    )
  }, [props.districts, venues])

  return (
    <div>
      {/* Results */}
      <ResultBrowser
        totalItems={100}
        itemsPerPage={0}
        loading={false}
        animationKey={""}
        scrollKey={filters.get("district")}
        tabs={{
          value: filters.get("district"),
          onValueChange: filters.setter("district") as any,
          items: [
            { label: "All", value: "all" },
            ...(districts.length > 0 ? districts : [{ label: "No districts", value: "none" }]),
          ],
        }}
      >
        <motion.div className="grid-auto" layoutRoot>
          <AnimatePresence mode="popLayout" initial={false} presenceAffectsLayout>
            {cards}
          </AnimatePresence>
        </motion.div>
      </ResultBrowser>
      <div className="h-10" />
    </div>
  )
})
